import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../../constants/ActionNameConstants';
import { PROOFREADER_MY_FILE_LIST_API_URL } from '../../../../../constants/ApiUrlConstants';
import { postApiRequest } from '../../../../../features/axiosClient';
import { proofreaderMyFilesFailure, proofreaderMyFilesSuccess } from '../actions';

const myFilesAPI = (action) => postApiRequest(PROOFREADER_MY_FILE_LIST_API_URL, action);

function* handleMyFilesAPI(action) {
  try {
    const response = yield call(myFilesAPI, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(proofreaderMyFilesSuccess(response));
  } catch (error) {
    yield put(proofreaderMyFilesFailure(error));
  }
}

export function* watchProofreaderMyFilesList() {
  yield takeLatest(types.GET_PROOFREADER_MY_FILES_LIST_REQUEST, handleMyFilesAPI);
}
